module.exports = __webpack_public_path__ + "static/media/groupChatImage-mobile.0f3ccca5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/groupChatImage-mobile.png
// module id = 932
// module chunks = 0